<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { cn } from '../../lib/utils'

  const props = defineProps<{
    class?: HTMLAttributes['class']
  }>()
</script>
<template>
  <div
    :class="
      cn(
        'text-foreground relative flex w-full select-none items-end gap-1 text-base font-semibold',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
